// Site information
export const APP_NAME = "MultiVox";
export const GITHUB_REPO = "https://github.com/rjpower/multivox";
export const CONTACT_EMAIL = "russell@wasabilabs.ai";

// API endpoints and configuration
export const GEMINI_API_URL = "https://aistudio.google.com/apikey";
